"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToTickerGroup = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _hooks = require("../../../../../hooks");
var _ticker = require("../../../../ticker");
var _ui = require("../../../../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ToTickerGroup = function ToTickerGroup() {
  var _useExchangeContext = (0, _hooks.useExchangeContext)(),
    toTicker = _useExchangeContext.toTicker,
    toTickers = _useExchangeContext.toTickers,
    balances = _useExchangeContext.balances,
    setToTicker = _useExchangeContext.setToTicker;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('chooseCurrencyToSend')), /*#__PURE__*/_react.default.createElement(_ticker.TickerSelectInput, {
    value: toTicker,
    tickers: toTickers,
    balances: balances,
    onChange: function onChange(value) {
      return setToTicker(value);
    }
  }));
};
exports.ToTickerGroup = ToTickerGroup;